export default __webpack_public_path__ + "static/media/ic1.81a10f32.svg";